const luhn = require('fast-luhn')
const moment = require('moment')

/**
 * century: matches[1]
 * date: matches[2]
 * digits: matches[3]
 * check: matches[4]
 **/
const FORMAT = /^(\d{2})(\d{6})(\d{3})(\d{1})$/

module.exports = function() {
  return value => {
    if (!value || !FORMAT.test(value)) return false

    const [, century, date, digits, check] = value.match(FORMAT)

    return moment(`${century}${date}`, 'YYYYMMDD').isValid() && luhn(`${date}${digits}${check}`)
  }
}
